import { authClient } from '@app/icare/client/auth'
import { DEV_USER_LABELS } from '@app/icare/shared/auth/devUserLabels'
import { Trans } from '@lingui/react/macro'
import { isProdStage } from '@pkg/shared/env'
import { useMutation } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'
import { Alert, Button } from 'antd'

export function DevSignIn() {
  const { mutateAsync, error, isPending, variables } = useMutation({
    throwOnError: false,
    mutationFn: async (devUserId: string) => {
      // Better Auth plugin endpoints are accessed via authClient.$fetch since
      // the devLogin plugin doesn't provide a matching client-side wrapper.
      await authClient.$fetch('/sign-in/dev', { method: 'POST', body: { devUserId } })
      window.location.reload()
    },
  })

  if (isProdStage) return null

  return (
    <div className="space-y-2 rounded-md border border-dashed border-amber-400 bg-amber-50 p-4">
      <div className="text-sm font-medium text-amber-700">
        <Trans>Dev-Login</Trans>
      </div>
      {error && (
        <Alert type="error" showIcon title={<Trans>Anmeldung fehlgeschlagen</Trans>} description={error.message} />
      )}
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {DEV_USER_LABELS.map(p => (
          <Button
            key={p.id}
            block
            loading={isPending && variables === p.id}
            disabled={isPending}
            onClick={() => mutateAsync(p.id)}
          >
            {p.label}
          </Button>
        ))}
      </div>
    </div>
  )
}
